import React from "react";

const Navbar = (props) => {
  const { setAboutSelected, setContactSelected } = props;

  return (
    <header>
      <p>Jason Adams</p>
      <nav>
        <ul>
          <li className="mx-2">
            <a href="#about">
              <span onClick={() => setAboutSelected(true)}>ABOUT</span>
            </a>
          </li>

          <li className="mx-1">
            <a href="#contact">
              <span onClick={() => setContactSelected(true)}>CONTACT INFO</span>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;